import { FC, useCallback } from "react";
import { MDSIconButton, MDSIconKind } from "@/mds";
import { electronModule } from "@/modules/electron";

interface DesktopMenuButtonProps {
  className?: string;
}

export const DesktopMenuButton: FC<DesktopMenuButtonProps> = ({ className }) => {
  const onClick = useCallback(() => {
    electronModule.toggleMenu();
  }, []);

  return (
    <MDSIconButton
      className={className}
      aria-label="Open menu"
      iconKind={MDSIconKind.Menu}
      onClick={onClick}
    />
  );
};
